import { useParams } from "react-router-dom";
import { Box, MenuItem, Select } from "@mui/material";
import DayNavigation from "../../../../../components/Live/navigation/DayNavigation.js";
import { useNavigateTo } from "../../../../hooks/useNavigateTo.js";
import { MatchsDisplay } from "../matchs/MatchsDisplay.js";

const MultiplexDay = ({live, liveCompetitionsDays}) => {
    const navigateTo = useNavigateTo();

    const { date } = useParams();

    const queryParameters = new URLSearchParams(window.location.search)
    const competition = queryParameters.get("competition")

    const handleCompetitionChange = (event) => {
        const selectedCompetition = liveCompetitionsDays.find(c => c._id === event.target.value)
        // Construire la nouvelle URL en remplaçant le paramètre 'date' et retire l'idmatch
        const newPath = window.location.pathname.replace(/\/day\/.*$/, `/day/${selectedCompetition.activeDay}`);

        navigateTo(newPath, {competition : event.target.value})
    };

    const navigateToNewDate = (newDate) => {
        // Replace le segment /day/OLD_DATE par /day/NEW_DATE et retire l'idmatch
        let newPath = window.location.pathname.replace(/\/day\/.*$/, `/day/${newDate}`);
      
        navigateTo(newPath);
    };

    return <Box>
        <Select
            value={competition}
            onChange={handleCompetitionChange}
            displayEmpty
            fullWidth
            sx={{ minWidth: 200 }}
            >
            <MenuItem value="" disabled>
                Sélectionner une compétition
            </MenuItem>
            {liveCompetitionsDays.map((competition) => (
                <MenuItem key={competition._id} value={competition._id}>
                {competition.name}
                </MenuItem>
            ))}
        </Select>
        <DayNavigation liveDates={liveCompetitionsDays.find(c=> c._id === competition).days} activeDate={date} setActiveDate={navigateToNewDate} />
        <MatchsDisplay live={live}/>
    </Box>
}

export default MultiplexDay